export default __webpack_public_path__ + "static/media/no-statements.7413e3fa.svg";